import * as React from 'react';

import * as RadixToggleGroupPrimitive from '@radix-ui/react-toggle-group';

import { cn } from 'src/utils/shadcn';

const ToggleGroup = React.forwardRef<
    React.ComponentRef<typeof RadixToggleGroupPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof RadixToggleGroupPrimitive.Root>
>(({ className, ...props }, ref) => (
    <RadixToggleGroupPrimitive.Root
        ref={ref}
        className={cn('border-input inline-flex rounded-md border', className)}
        {...props}
    />
));
ToggleGroup.displayName = RadixToggleGroupPrimitive.Root.displayName;

const ToggleGroupItem = React.forwardRef<
    React.ComponentRef<typeof RadixToggleGroupPrimitive.Item>,
    React.ComponentPropsWithoutRef<typeof RadixToggleGroupPrimitive.Item>
>(({ className, ...props }, ref) => (
    <RadixToggleGroupPrimitive.Item
        ref={ref}
        className={cn(
            'border bg-gray-100 px-3 py-1.5 text-sm font-medium',
            'hover:bg-muted transition-colors',
            'data-[state=on]:bg-white data-[state=on]:text-white',
            '-ml-px first:ml-0 first:rounded-l-md last:rounded-r-md',
            'focus-visible:ring-ring focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2',
            className,
        )}
        {...props}
    />
));
ToggleGroupItem.displayName = RadixToggleGroupPrimitive.Item.displayName;

export { ToggleGroup, ToggleGroupItem };
